var exports = {
  "x6": "AutocompleteItem.module__button___VUlOZz",
  "kL": "AutocompleteItem.module__container___VUlOZz",
  "wH": "AutocompleteItem.module__selected___VUlOZz",
  "Qs": "AutocompleteItem.module__content___VUlOZz",
  "Kk": "AutocompleteItem.module__icon___VUlOZz",
  "Bm": "AutocompleteItem.module__nameWrapper___VUlOZz",
  "UU": "AutocompleteItem.module__name___VUlOZz",
  "h_": "AutocompleteItem.module__description___VUlOZz",
};

module.exports = exports;
